import { ArticleFilterAttributeValue } from '@generated'

export function getSelectedCollectionSlug(
  articleFilterAttributeValues: ArticleFilterAttributeValue[],
  activeCollectionFilters: string[],
): string | undefined {
  if (!articleFilterAttributeValues.length || !activeCollectionFilters.length) {
    return undefined
  }

  return articleFilterAttributeValues
    .find(({ attributeValueID }) => attributeValueID === Number(activeCollectionFilters[0]))
    ?.attributeValue.toLowerCase()
    .replace(/ /g, '-')
}
